import { combineReducers } from 'redux';
import session from './session_reducer';
import ErrorsReducer from './errors_reducer';
import user from './users_reducer';
import file from './file_reducer';
import courses from './courses_reducer';
import userProfile from './userProfile_reducer';
import courseSections from './courseSections_reducer';
import student from './student_reducer';
import admin from './admin_reducer';
import messages from './messages_reducer';
import enrollmentsReducer from './enrollments_reducer';
import courseResourcesReducer from './course_resources_reducer';


const RootReducer = combineReducers({
  user,  
  errors: ErrorsReducer, 
  admin,
  session,
  file,
  courses,
  userProfile,
  courseSections,
  student,
  messages,
  enrollments: enrollmentsReducer,
  courseResources: courseResourcesReducer
});

export default RootReducer;